var map = {
	"./1200x100.png": "WFps",
	"./1200x150.png": "LFUT",
	"./242x340.png": "JdFK",
	"./456x206.png": "oROX",
	"./594x100_2.png": "WzjM",
	"./PK10.png": "nsVc",
	"./bjpknum.png": "t7Eb",
	"./choose5.png": "Cado",
	"./closeMenu.png": "Pp6S",
	"./hot.png": "fy6o",
	"./hpten.png": "scMI",
	"./ks.png": "fCL5",
	"./menu.png": "01ru",
	"./mobile/download.png": "zO+i",
	"./mobile/lobby.png": "FfQq",
	"./mobile/map.png": "u8mT",
	"./mobile/plan.png": "gom3",
	"./nn.png": "R5KT",
	"./ssc.png": "yAHu",
	"./table_bg.png": "w4Ib",
	"./tuijian.png": "a4S7",
	"./xyrb.png": "ZA0a",
	"./zwt.png": "HOyz"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "zfj7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\.png$
// module id = zfj7
// module chunks = 7